export const arrow_down = () => (
  <path
    d="M12 5v14m0 0l7-7m-7 7l-7-7"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
